import { useEffect } from 'react';

import { syncNavioBuildOfflineQueue } from './offline-sync';

export function useOfflineQueueSync(enabled = true): void {
  useEffect(() => {
    if (!enabled || typeof window === 'undefined') return;

    let cancelled = false;
    const sync = () => {
      if (!cancelled) {
        syncNavioBuildOfflineQueue().catch((error) => {
          console.error('NavioBuild offline queue sync failed', error);
        });
      }
    };

    sync();
    window.addEventListener('online', sync);
    const interval = window.setInterval(sync, 30_000);

    return () => {
      cancelled = true;
      window.removeEventListener('online', sync);
      window.clearInterval(interval);
    };
  }, [enabled]);
}
